// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FnOQk9b7uS94eQmpyeTK{height:100%}.FnOQk9b7uS94eQmpyeTK>*{height:100%}.pVqgRilteLsB7qGVVzx1{padding:0 12px}`, "",{"version":3,"sources":["webpack://./src/app/common/containers/home.container/style.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CAEA,wBACE,WAAA,CAIJ,sBACE,cAAA","sourcesContent":[".product-item-wrapper {\n  height: 100%;\n\n  > * {\n    height: 100%;\n  }\n}\n\n.product-item-wrapper--carousel {\n  padding: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product-item-wrapper": `FnOQk9b7uS94eQmpyeTK`,
	"product-item-wrapper--carousel": `pVqgRilteLsB7qGVVzx1`
};
export default ___CSS_LOADER_EXPORT___;
